import { render } from "./TemaEnergi.vue?vue&type=template&id=15109d90"
import script from "./TemaEnergi.vue?vue&type=script&lang=js"
export * from "./TemaEnergi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__